angular.module('rjmNg.services').factory "freeTrialBillingModalService", [
  "app"
  "$q"
  "Billing"
  "Clients"
  "FEATURE_TIER"
  (
    app
    $q
    Billing
    Clients
    FEATURE_TIER
  ) ->
    #TODO: This service can go away once we migrate all essentials clients to magento marketplace

    _clientHasMagentoSubscription = (clientInfo) ->
      return clientInfo?.properties?.magento_subscription_id? and
        clientInfo?.properties?.magento_subscription_id isnt ""

    shouldShowModal: () ->
      deferred = $q.defer()

      if not app.isOverdueModalEnabled()
        deferred.resolve(display: false)

      $q.all([
        Billing.getStatus(app.getClientId()),
        Clients.get(app.getClientId())
      ]).then ([billingStatus, clientInfo]) =>

        # For clients that have their billing migrated to magento marketplace
        # we don't have to show the free trial modal, since there is no action
        # they need to take (Magento already has their CC)
        if _clientHasMagentoSubscription(clientInfo)
            deferred.resolve(display: false)

        # PRO tier, ECE, and MOM clients do not have free trials
        if clientInfo?.properties?.feature_tier is FEATURE_TIER.PREMIUM.toString() \
          or app.isBillingExempt()
            deferred.resolve(display: false)

        # don't show free trial modal when client any form of payment entered
        if billingStatus?.DefaultPaymentMethod?.length and billingStatus?.isActive is "true"
          deferred.resolve(display: false)

        # don't show free trial modal when client recently entered a cc
        if billingStatus?.cached_payment?
          deferred.resolve(display: false)

        daysRemaining = billingStatus?.free_trial?.days_remaining
        if daysRemaining? and daysRemaining <= 3
          deferred.resolve(display: true)
        else
          deferred.resolve(display: false)

        deferred.promise
      .catch () ->
]
